"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileApp = void 0;
var androidAppURL = 'https://play.google.com/store/apps/details?id=com.feather.app';
var iosAppURL = 'https://apps.apple.com/us/app/feather-insurance/id6450698867';
exports.mobileApp = {
    androidAppURL: androidAppURL,
    iosAppURL: iosAppURL,
};
